const getGa = (): any => (typeof window !== 'undefined' && window.ga ? window.ga : null);

const getTracker = (): any => {
  const ga = getGa();

  if (ga) {
    return ga.hasOwnProperty('getAll') ? ga.getAll()[0] : null;
  }

  return null;
};

const getClientID = (): any => {
  const tracker = getTracker();
  return tracker ? tracker.get('clientId') : null;
};

export { getGa, getTracker, getClientID };
